export default __webpack_public_path__ + "static/media/registered.a98adcf5.png";